import { createSlice, createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { isPlatformNodeJS } from '@utils/common';
import { createIndependentStore } from '@utils/react';
import { componentFrameworkSelectors } from './index.selectors.js';

const initialState = {
  activeComponentId: void 0,
  overlayContainerSelector: void 0
};
const slice = createSlice({
  name: "provider/component-framework",
  initialState,
  reducers: {
    activateComponent(state, action) {
      state.activeComponentId = action.payload;
    },
    deactivateComponent(state, action) {
      if (state.activeComponentId === action.payload) {
        state.activeComponentId = void 0;
      }
    },
    setOverlayContainer(state, action) {
      state.overlayContainerSelector = action.payload;
    }
  }
});
const middleware = createListenerMiddleware();
function applyComponentFrameworkClassnamesMiddleware() {
  const applyClassNames = () => {
    if (isPlatformNodeJS()) {
      return;
    }
    const isActive = !!componentFrameworkStore.getState().activeComponentId;
    document.body.classList.toggle(
      componentFrameworkSelectors.isActive.className,
      isActive
    );
  };
  middleware.startListening({
    matcher: isAnyOf(
      slice.actions.activateComponent,
      slice.actions.deactivateComponent
    ),
    effect: applyClassNames
  });
  return () => {
    middleware.stopListening({
      matcher: isAnyOf(
        slice.actions.activateComponent,
        slice.actions.deactivateComponent
      ),
      effect: applyClassNames
    });
  };
}
const componentFrameworkStore = createIndependentStore({
  ...slice,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(middleware.middleware)
});
const useComponentFrameworkState = componentFrameworkStore.useSelector;

export { applyComponentFrameworkClassnamesMiddleware, componentFrameworkStore, slice, useComponentFrameworkState };
//# sourceMappingURL=store.js.map
